import { IBaseCellsProps } from '../../cells.interfaces';
import { StyledTableCell } from '../../CellMenu/CellMenu.styles';
import { Icon, IconButton } from '../../../../base-components';

const CellMenuSkeleton = (props: IBaseCellsProps) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={false}
        >
            <IconButton disabled>
                <Icon name={'MoreVertIcon'} />
            </IconButton>
        </StyledTableCell>
    );
};

export default CellMenuSkeleton;
